/**
 * Meta flag condivisi per l'estrazione delle competenze dallo schema.
 *
 * Le competenze sono un concetto generale: possono provenire dal widget
 * Selezione Competenza (un valore scalare per widget) oppure dal widget
 * Mappa (una lista di risultati calcolati a runtime). Entrambi marcano i
 * propri campi con gli stessi flag primario/secondario, così che una
 * singola funzione di estrazione possa attraversare lo schema una sola
 * volta. Il meta `source` discrimina l'origine e quindi il formato del
 * valore del nodo (scalare vs array di item).
 */

/**
 * Marca un campo dello schema che porta una o più competenze.
 */
export const CompetenceMetaFlag = 'isCompetenceField';

/**
 * Marca un campo competenza come secondario (ruolo non primario).
 */
export const CompetenceSecondaryMetaFlag = 'isSecondaryCompetenceField';

/**
 * Origine della competenza. Determina il formato del valore del nodo:
 * `Widget` = valore scalare (idCompetenza), `Map` = array di item.
 */
export enum CompetenceSource {
  Widget = 'widget',
  Map = 'map',
}

/**
 * Chiave meta che indica l'origine della competenza.
 */
export const CompetenceSourceMetaKey = 'competenceSource';

/**
 * Chiave meta che porta l'id del tipo di competenza secondaria
 * configurato sul widget Selezione Competenza (valore di config, non
 * runtime). Usata solo per il ramo `'widget'`.
 */
export const CompetenceSecondaryTypeIdMetaKey = 'secondaryCompetenceTypeId';
